import React, { useState, useEffect, useRef } from 'react';

const BIG_MESSAGES = [
  // 🇷🇺 Русский — нежные
  'Ты — главное в этой жизни.\nТы не просто человек — ты моё любимое место на Земле.',
  'Всё, что было до тебя, было просто временем.\nА всё, что после — это жизнь.\nСпасибо, что ты есть.',
  'В совпадения не верю, но встретить тебя —\nслишком точное попадание.\nВселенная знала, к кому вести.',
  'Рядом с тобой тишина становится уютной.\nПросто рядом — и всё встаёт на свои места.\nЭто редкость.',
  'Из-за тебя хочется просыпаться утром.\nНе потому что надо.\nА потому что ты есть.',
  'Вот что значит дома:\nне адрес, не стены.\nПросто ты рядом.',
  'Твой смех — и хочется запомнить этот момент.\nПоставить на паузу. Остаться в нём.\nНавсегда.',
  'Весь мир может идти не так.\nНо если ты рядом — это всё равно хороший день.',
  'Говорю об этом слишком редко,\nно ты — лучшее, что случилось в моей жизни.\nЭто правда.',
  'Ты входишь — и всё меняется.\nНе громко. Не внезапно.\nПросто становится лучше.',
  'Не нужна идеальная жизнь.\nНужна жизнь, в которой есть ты.\nЭтого достаточно.',
  'О тебе думаю, когда слышу хорошую музыку.\nЭто много значит.\nБольше, чем кажется.',
  'Хочется написать тебе тысячу сообщений,\nно самое важное только одно:\nты нужен мне рядом.',
  'Есть люди, которые согревают одним присутствием.\nТы — из таких.\nПусть знаешь об этом.',
  'Рядом с тобой становлюсь лучше.\nТихо. Незаметно. Точно.\nСпасибо за это.',
  'Иногда хочется сказать тебе всё сразу.\nИ молчу.\nНо ты — моё лучшее.',

  // 🇷🇺 Русский — дерзкие / смущающие
  'Ты слишком притягательный — устоять невозможно,\nи слишком тёплый — не привязаться нельзя.\nИ не надо.',
  'Ты занимаешь мысли без разрешения\nи съезжать явно не планируешь.\nЯ уже не против.',
  'Смотришь — и мысли рассыпаются.\nЭто невыносимо.\nЭто лучшее, что бывает.',
  'Хочется быть той мыслью,\nкоторая мешает тебе уснуть.\nНадеюсь, получается.',
  'С тобой даже провалиться в кроличью нору —\nхорошая идея.\nНе раздумывая.',
  'Страшнее всего — потерять тебя.\nПоэтому держусь.',
  'Хочется сказать: ты слишком хорош(а).\nНо не хочется пугать.\nПоэтому просто — ты.',

  // 🇰🇬 Кыргызча — нежные
  'Сен кеткенде жүрөгүм бош болот.\nСен жок болсо — жетишпей калат.\nСен — менин эң жакшы адамым.',
  'Сени тандаганда бүтүн дүйнө жакшыраак көрүнөт.\nСен жылмайсаң — мага баары жеңил.\nСенин жылуулугуң — менин үйүм.',
  'Сенин жаныңда болгондо — менин бары бар.\nСенин жаныңда болсом — жашоо жеңил.\nСен — менин дүйнөмдүн борбору.',
  'Сенин жылмаюуң — эң керектүү нерсе.\nСенин үнүң — мага музыка.\nСен — жашоомдун мааниси.',
  'Сен менен болгондо убакыт тез өтөт.\nАл тез өтсүн деп каалабайм.\nСен — менин эң сонун убактым.',
  'Сени жакшы билгем сайын\nдагы бир аз сүйүп калам.\nБул токтобойт окшойт.',
  'Сен жылмайсаң — дүйнөм жарыктанат.\nСен кайгырсаң — мен да бирге сезем.\nБиз ушундаймыз.',
  'Сенин каршыңда отурганда\nдүйнөнүн башка жери маанисиз болуп калат.\nСен — менин бардыгым.',
  'Сенден алыста болуу — кыйын.\nСенин жаныңда болуу — бакыт.\nТаңдаган сайын — сенин жаныңды тандайм.',
  'Сени биринчи жолу көргөндө\nбир нерсе өзгөрдү ичимде.\nАлиге чейин өзгөрүп жатат.',
  'Сен жөнүндө ойлогондо\nжүзүмдө жылмаюу пайда болот өзүнөн-өзү.\nСен — менин сыйкырым.',
  'Сен болбосоң, дүйнө дагы бир аз кем.\nСен болгондо — баары жеткиликтүү.\nАртык эмепмин.',
  'Сени карагым келет узак.\nТыңшагым келет каалаганда.\nСенин жанында болуу — жалаң бакыт.',
  'Сен — кадыресе адам эмессиң.\nСен — мага берилген эң жакшы нерсе.\nОшондой жашап жатам.',

  // 🇰🇬 Кыргызча — дерзкие / смущающие
  'Сен өтө сулуусуң — бул адилетсиздик.\nБир жылмайсаң — тил байланат.\nКалай кылгандай урдуң?',
  'Сени карасам — акылым башка жакка кетет.\nОшол башка жак — дайым сен жагыңда.\nТокто эле.',
  'Сен жылмайсаң — баары пайда болот.\nСен кетсең — баары жоголот.\nМинтип эле жашайм.',

  // 🇬🇧 English
  'Before you, I thought I understood what good felt like.\nThen you walked in and rewrote the definition.\nNow I can\'t go back.',
  'I don\'t need the whole world to go right.\nI just need you nearby —\nand somehow everything becomes enough.',
  'You\'re the kind of person I want to tell things to first.\nBefore I\'ve even processed them myself.\nYou just make sense to me.',
  'I used to think love was a feeling.\nBut with you it\'s a decision I make every single day —\nand I\'ve never once regretted it.',
  'Somewhere between your laugh\nand the way you look when you\'re thinking —\nI lost the ability to imagine life without you.',
  'You don\'t have to do anything spectacular.\nJust being you, in the same room as me,\nis already the best part of my day.',
  'I don\'t know what I did to deserve\nsomeone as remarkable as you —\nbut I\'m not questioning it.',
  'There\'s a kind of quiet happiness\nthat only exists when you\'re nearby.\nI\'m addicted to it.',
  'The world is loud and messy.\nBut somehow, next to you,\nit all gets a little softer.',
  'I notice everything about you.\nThe way you talk, the way you think.\nI just really like you.',
  'You make the ordinary feel like a gift.\nNot because you try —\nbut because you\'re just like that.',
  'I\'ve started associating good songs\nwith moments that have you in them.\nThat\'s a compliment.',
  'You walked into my life quietly\nand somehow rearranged everything.\nI\'m grateful for the mess.',
  'I don\'t say it enough, but —\nyou are one of the best things\nthat has ever happened to me.',
  'You\'re ridiculously hard to stop thinking about.\nI\'ve tried.\nI\'ve stopped trying.',
  'The nerve of you — existing like that\nand expecting me not to notice.\nRude. Perfect. You.',
];

const MESSAGES = [
  // 🇷🇺 Русский — нежные
  'Ты делаешь мир ярче',
  'С тобой даже понедельник — праздник',
  'Твои глаза — это нечестно',
  'Без тебя скучнее гравитация',
  'Ты — моя любимая случайность',
  'Рядом с тобой хочется выдохнуть',
  'Ты — мой выбор в каждой жизни',
  'Ты умеешь делать тишину уютной',
  'С тобой хочется замедлить время',
  'Любить тебя — самое правильное',
  'Твоё присутствие — уже подарок',
  'Невозможно не улыбнуться рядом с тобой',
  'Думаю о тебе, когда слышу хорошую музыку',
  'Видеть тебя — уже хороший день',
  'Мне нравится, как ты думаешь',
  'Твой смех — мой любимый звук',
  'Ты — лучшая часть любого дня',
  'Продолжаю думать о тебе. Очень.',
  'Рядом с тобой хочется быть лучше',
  'Ты — это то, о чём мечтают',

  // 🇷🇺 Русский — дерзкие / смущающие
  'Ты слишком притягательный — это несправедливо',
  'Не из тех, кто влюбляется легко, но ты — исключение',
  'Твоя улыбка — читерство',
  'Смотришь — и мысли рассыпаются. Обожаю.',
  'Мысли о тебе появляются без предупреждения',
  'Ты — баг в моей системе. Фиксить не буду',
  'Хочется быть мыслью, что мешает тебе спать',
  'С тобой даже кроличья нора — хорошая идея',
  'Слишком идеальный — это подозрительно',
  'Ты — конечная остановка. Дальше не еду',
  'Смотришь так — у меня кончаются слова. Редкость.',
  'Сложно думать о чём-то ещё, когда ты рядом',
  'Ты занимаешь 100% мыслей. Места для остальных нет',
  'Хотелось бы притвориться равнодушным — не выходит',
  'Иногда хочется сказать тебе всё сразу. И молчу.',
  'Ты слишком хорош(а) — это невыносимо и прекрасно',
  'Ты — лучший краш, что мог случиться',
  'Ты занял место в голове и не собираешься съезжать',

  // 🎮 CS2 стиль
  'gg ez — ты лучший раунд моей жизни',
  'У меня нет wallhack, но тебя вижу насквозь ♡',
  'Ты — ace в каждом раунде моего сердца',
  'Clutch 1v5? Легко, если ты рядом',
  'TOP FRAG — это ты. Всегда.',
  'Кидаю смоук — чтоб никто нас не разлучил',

  // ⛏️ Minecraft стиль
  'Ты — алмаз в мире деревянных инструментов',
  'Без тебя мой мир — просто пустой чанк',
  'Ты — netherite в инвентаре сердца',
  'Ты — Elytra. С тобой можно летать',
  'Построил(а) бы целый мир ради тебя',
  'Respawn рядом с тобой — лучшая точка',

  // 💻 Git / IT стиль
  'git commit -m "нет отката от этого чувства"',
  'Ты — единственный merge без конфликтов',
  'В жизни только одна ветка: ты',
  'Ты — production. Всё остальное — staging',
  'Ты не баг — ты фича, которую не ожидали',
  'Твой pull request принят. Навсегда.',
  'localhost:3000 — это твоя улыбка в голове',

  // 🇰🇬 Кыргызча — нежные
  'Сен — жүрөгүмдүн жообу',
  'Сенин жылмаюуң — мага эң сонун дары',
  'Сен — таптым эң сонун байлык',
  'Сенин жаныңда болуу — бакыт',
  'Сен — жылдыздардан да нурлуусуң',
  'Сенин үнүң — музыканын эң жакшы сабы',
  'Сен менен убакыт тез өтөт',
  'Сен болгону — менин бактым',
  'Сенин жаныңда жашоо жеңил',
  'Сен — мага берилген эң жакшы нерсе',
  'Сен жөнүндө ойлосом — жылмайып коём',
  'Сен менен болуу — жашоонун мааниси',
  'Сени карагым келет узак убакыт',

  // 🇰🇬 Кыргызча — дерзкие / смущающие
  'Сен өтө сулуусуң — бул адилетсиздик',
  'Сен мени карасаң — жүрөгүм ылдам кагат',
  'Сенин мүнөзүң — мени кармап турган жип',
  'Сен жылмайсаң — баары пайда болот',
  'Сенден алыс болуу — интернетсиз калгандай',
  'Сен — менин эң жакшы ката',
  'Сен бир сүйлөсөң — бардыгы жарашат',
  'Сенин жанында болгондо акылым башка жакка кетет',
  'Сен — мага адатта болбогон нерсе',
  'Сени карасам токтой албайм',
  'Сен — менин акылымды орун алган адам',
  'Сен мага тиешелүүсүң — билесиңби?',

  // 🇬🇧 English
  'You make chaos look beautiful',
  'You\'re the plot twist I didn\'t see coming',
  'Your laugh is my favourite sound',
  'I\'d pick you in every timeline',
  'You make ordinary days feel cinematic',
  'You light up rooms you haven\'t even entered yet',
  'You\'re suspiciously perfect — show me your docs',
  'You\'re the main character and I\'m glad to be here',
  'You crashed my thoughts and refused to uninstall',
  'If you were a commit message: "fixed everything"',
  'You\'re the final boss of my heart and I\'m not fighting back',
  'The audacity of you — being this good',
  'You\'re the tab I never close',
  'I\'d choose you even on a bug-filled Monday',
  'You\'re everything the algorithm was trying to find',
];

const ValentineMode = ({ audioContext, isSoundEnabled }) => {
  const [hearts, setHearts] = useState([]);
  const [letters, setLetters] = useState([]);
  const [bigValentine, setBigValentine] = useState(null);
  const [microHearts, setMicroHearts] = useState([]);
  const [flowParticles, setFlowParticles] = useState([]);
  const [isFlowActive, setIsFlowActive] = useState(false);
  const [showHint, setShowHint] = useState(true);
  const [hoveredLetterId, setHoveredLetterId] = useState(null);
  const [lastRClickTime, setLastRClickTime] = useState(0);
  const [rClickCount, setRClickCount] = useState(0);
  const animFrameRef = useRef(null);
  const handlersRef = useRef({});
  const lettersRef = useRef([]);

  useEffect(() => {
    const t = setTimeout(() => setShowHint(false), 7000);
    return () => clearTimeout(t);
  }, []);

  // ─── AUDIO ─────────────────────────────────────────────────────────────────
  const playHeartSound = () => {
    if (!audioContext || !isSoundEnabled) return;
    const now = audioContext.currentTime;
    // Crystal bell — fundamental + 2nd harmonic + shimmer
    [[523.25, 0.052], [1046.5, 0.028], [1568.0, 0.016]].forEach(([freq, vol], i) => {
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();
      const filter = audioContext.createBiquadFilter();
      osc.connect(filter); filter.connect(gain); gain.connect(audioContext.destination);
      filter.type = 'lowpass'; filter.frequency.value = 5000;
      osc.type = 'sine'; osc.frequency.value = freq;
      const t = now + i * 0.025;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(vol, t + 0.018);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 2.2 - i * 0.4);
      osc.start(t); osc.stop(t + 2.3);
    });
    // Tiny warm pad underneath
    const pad = audioContext.createOscillator(); const padG = audioContext.createGain();
    pad.connect(padG); padG.connect(audioContext.destination);
    pad.type = 'triangle'; pad.frequency.value = 329.63;
    padG.gain.setValueAtTime(0, now); padG.gain.linearRampToValueAtTime(0.018, now + 0.06);
    padG.gain.exponentialRampToValueAtTime(0.001, now + 1.0);
    pad.start(now); pad.stop(now + 1.1);
  };

  const playLetterSound = () => {
    if (!audioContext || !isSoundEnabled) return;
    const now = audioContext.currentTime;
    // Gentle harp arpeggio ascending
    [261.63, 329.63, 392.0, 493.88, 523.25, 659.26].forEach((freq, i) => {
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();
      const filter = audioContext.createBiquadFilter();
      osc.connect(filter); filter.connect(gain); gain.connect(audioContext.destination);
      filter.type = 'lowpass'; filter.frequency.value = 3500;
      osc.type = 'triangle'; osc.frequency.value = freq;
      const t = now + i * 0.075;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.038, t + 0.022);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 1.6);
      osc.start(t); osc.stop(t + 1.7);
    });
  };

  const playBigValentineSound = () => {
    if (!audioContext || !isSoundEnabled) return;
    const now = audioContext.currentTime;
    // Full warm pad chord first
    [261.63, 329.63, 392.0, 523.25].forEach((freq) => {
      const osc = audioContext.createOscillator(); const g = audioContext.createGain();
      osc.connect(g); g.connect(audioContext.destination);
      osc.type = 'sine'; osc.frequency.value = freq;
      g.gain.setValueAtTime(0, now);
      g.gain.linearRampToValueAtTime(0.038, now + 0.4);
      g.gain.linearRampToValueAtTime(0.03, now + 2.2);
      g.gain.exponentialRampToValueAtTime(0.001, now + 4.0);
      osc.start(now); osc.stop(now + 4.1);
    });
    // Ascending sparkle cascade over the chord
    [261.63, 329.63, 392, 466.16, 523.25, 587.33, 659.26, 739.99, 830.61, 932.33, 1046.5].forEach((freq, i) => {
      const osc = audioContext.createOscillator(); const g = audioContext.createGain();
      const f = audioContext.createBiquadFilter();
      osc.connect(f); f.connect(g); g.connect(audioContext.destination);
      f.type = 'lowpass'; f.frequency.value = 5000;
      osc.type = 'sine'; osc.frequency.value = freq;
      const t = now + i * 0.09;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.048, t + 0.022);
      g.gain.exponentialRampToValueAtTime(0.001, t + 2.8);
      osc.start(t); osc.stop(t + 2.9);
    });
  };

  const playFlowSound = (active) => {
    if (!audioContext || !isSoundEnabled) return;
    if (active) {
      if (audioContext.state === 'suspended') audioContext.resume();
      const now = audioContext.currentTime;
      // Dreamy sustained pad — love chord with gentle LFO shimmer
      const nodes = [261.63, 329.63, 392.0, 523.25].map((freq, i) => {
        const osc = audioContext.createOscillator();
        const lfo = audioContext.createOscillator();
        const lfoG = audioContext.createGain();
        const gain = audioContext.createGain();
        const filter = audioContext.createBiquadFilter();
        lfo.connect(lfoG); lfoG.connect(osc.frequency);
        osc.connect(filter); filter.connect(gain); gain.connect(audioContext.destination);
        filter.type = 'lowpass'; filter.frequency.value = 1200;
        lfo.type = 'sine'; lfo.frequency.value = 0.3 + i * 0.08; lfoG.gain.value = 3;
        osc.type = 'sine'; osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(0.038, now + 1.4);
        lfo.start(now); osc.start(now);
        return { osc, lfo, gain };
      });
      window._valentineFlowNodes = nodes;
    } else {
      if (window._valentineFlowNodes) {
        const now = audioContext.currentTime;
        window._valentineFlowNodes.forEach(({ gain, osc, lfo }) => {
          gain.gain.cancelScheduledValues(now);
          gain.gain.setValueAtTime(gain.gain.value, now);
          gain.gain.linearRampToValueAtTime(0, now + 0.7);
          setTimeout(() => { try { osc.stop(); lfo.stop(); } catch(e){} }, 800);
        });
        window._valentineFlowNodes = null;
      }
    }
  };

  // ─── ANIMATION LOOP ────────────────────────────────────────────────────────
  useEffect(() => {
    const tick = () => {
      const now = Date.now();

      setHearts(prev => prev.map(h => ({
        ...h,
        y: h.y - h.speed,
        x: h.x + Math.sin((now - h.born) / 620 + h.phase) * 0.55,
        opacity: Math.max(0, 1 - (now - h.born) / h.duration),
      })).filter(h => h.opacity > 0));

      setLetters(prev => {
        const next = prev.map(l => ({
          ...l,
          y: l.y - l.speed,
          x: l.x + Math.sin((now - l.born) / 820 + l.phase) * 0.28,
          opacity: Math.max(0, 1 - (now - l.born) / l.duration),
          openProgress: Math.min(1, Math.max(0, (now - l.born - (l.openDelay || 400)) / 900)),
        })).filter(l => l.opacity > 0.01);
        lettersRef.current = next;
        return next;
      });

      setMicroHearts(prev => prev.map(h => ({
        ...h,
        x: h.x + h.vx,
        y: h.y + h.vy,
        vy: h.vy - 0.07,
        vx: h.vx * 0.97,
        opacity: Math.max(0, h.opacity - 0.011),
        scale: Math.max(0.1, h.scale * 0.994),
      })).filter(h => h.opacity > 0));

      setBigValentine(prev => {
        if (!prev) return null;
        const age = now - prev.born;
        if (age > 9000) return null;
        // Visible for 7s, then fades over 2s
        const opacity = age < 7000 ? 1 : Math.max(0, 1 - (age - 7000) / 2000);
        return { ...prev, opacity, opened: age > 900, scale: Math.min(1, age / 350) };
      });

      setFlowParticles(prev => {
        const updated = prev.map(p => ({
          ...p,
          x: p.x + p.vx,
          y: p.y + p.vy + Math.sin(now / 620 + p.phase) * 0.45,
          opacity: (p.x > window.innerWidth + 50 || !isFlowActive)
            ? Math.max(0, p.opacity - 0.022)
            : p.opacity,
        })).filter(p => p.opacity > 0 && p.x < window.innerWidth + 70);
        if (!isFlowActive) return updated;
        if (Math.random() > 0.42) {
          updated.push({
            id: now + Math.random(),
            x: -15, y: 40 + Math.random() * (window.innerHeight - 80),
            vx: 2.0 + Math.random() * 1.6,
            vy: (Math.random() - 0.5) * 0.55,
            phase: Math.random() * Math.PI * 2,
            hue: 320 + Math.random() * 55,
            size: 7 + Math.random() * 11,
            type: Math.random() > 0.38 ? 'heart' : 'dot',
            opacity: 0.55 + Math.random() * 0.45,
          });
        }
        return updated;
      });

      animFrameRef.current = requestAnimationFrame(tick);
    };
    animFrameRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animFrameRef.current);
  }, [isFlowActive]);

  // ─── INTERACTION ──────────────────────────────────────────────────────────
  handlersRef.current = {
    handleMouseDown: (e) => {
      if (e.button === 0) {
        // Letters
        setLetters(prev => [...prev, {
          id: Date.now() + Math.random(),
          x: e.clientX + (Math.random() - 0.5) * 16,
          y: e.clientY,
          speed: 0.38 + Math.random() * 0.28,
          phase: Math.random() * Math.PI * 2,
          opacity: 1, opened: false,
          duration: 5500 + Math.random() * 2000,
          born: Date.now(),
          openDelay: 350 + Math.random() * 180,
          message: MESSAGES[Math.floor(Math.random() * MESSAGES.length)],
          hue: 335 + Math.random() * 35,
          size: 26 + Math.random() * 12,
        }]);
        setShowHint(false);
        playLetterSound();
      }
      if (e.button === 2) {
        const now = Date.now();
        const tSince = now - lastRClickTime;
        if (tSince < 350 && rClickCount === 1) {
          // Double RMB: big valentine + micro-heart burst
          setBigValentine({ id: now, x: e.clientX, y: e.clientY, born: now, opacity: 1, opened: false, scale: 0,
            message: BIG_MESSAGES[Math.floor(Math.random() * BIG_MESSAGES.length)] });
          setMicroHearts(prev => [...prev, ...Array.from({ length: 20 }).map((_, i) => ({
            id: now + i + Math.random(),
            x: e.clientX, y: e.clientY,
            vx: (Math.random() - 0.5) * 5.5,
            vy: -1.2 - Math.random() * 3.2,
            size: 5 + Math.random() * 9,
            hue: 330 + Math.random() * 50,
            scale: 0.8 + Math.random() * 0.7,
            opacity: 0.92,
          }))]);
          playBigValentineSound();
          setRClickCount(0);
        } else {
          setRClickCount(1);
          setTimeout(() => setRClickCount(0), 350);
          // Single RMB: floating hearts
          setHearts(prev => [...prev, ...Array.from({ length: 4 + Math.floor(Math.random() * 4) }).map((_, i) => ({
            id: Date.now() + i + Math.random(),
            x: e.clientX + (Math.random() - 0.5) * 50,
            y: e.clientY,
            size: 9 + Math.random() * 15,
            hue: 330 + Math.random() * 50,
            speed: 0.75 + Math.random() * 0.95,
            phase: Math.random() * Math.PI * 2,
            opacity: 1,
            duration: 3200 + Math.random() * 2200,
            born: Date.now(),
          }))]);
          playHeartSound();
        }
        setLastRClickTime(now);
        setShowHint(false);
      }
      if (e.button === 1) {
        e.preventDefault();
        setIsFlowActive(true);
        playFlowSound(true);
        setShowHint(false);
      }
    },
    handleMouseUp: (e) => {
      if (e.button === 1) {
        setIsFlowActive(false);
        playFlowSound(false);
      }
    },
  };

  useEffect(() => {
    const down = (e) => handlersRef.current.handleMouseDown(e);
    const up = (e) => handlersRef.current.handleMouseUp(e);
    const ctx = (e) => e.preventDefault();
    const move = (e) => {
      const mx = e.clientX, my = e.clientY;
      const letters = lettersRef.current;
      let found = null;
      for (const l of letters) {
        const w = l.size * 1.5 * 0.5;
        const h = l.size * 0.5;
        if (mx >= l.x - w && mx <= l.x + w && my >= l.y - h && my <= l.y + h) {
          found = l.id; break;
        }
      }
      setHoveredLetterId(found);
    };
    window.addEventListener('mousedown', down);
    window.addEventListener('mouseup', up);
    window.addEventListener('contextmenu', ctx);
    window.addEventListener('mousemove', move);
    return () => {
      window.removeEventListener('mousedown', down);
      window.removeEventListener('mouseup', up);
      window.removeEventListener('contextmenu', ctx);
      window.removeEventListener('mousemove', move);
    };
  }, []);

  const heartPath = (cx, cy, size) => {
    const s = size;
    return `M${cx},${cy + s*0.28} C${cx - s*1.15},${cy - s*0.85} ${cx - s*2.0},${cy + s*0.75} ${cx},${cy + s*1.82} C${cx + s*2.0},${cy + s*0.75} ${cx + s*1.15},${cy - s*0.85} ${cx},${cy + s*0.28}Z`;
  };

  const renderLetter = (l) => {
    const w = l.size * 1.5;
    const h = l.size;
    const op = l.openProgress || 0;
    // Cubic ease-out for smooth flap swing
    const eased = 1 - Math.pow(1 - op, 3);
    const flapMidY = -h * 1.15 * eased; // flap tip: 0 (closed) → -h*1.15 (fully open/up)
    const textOpacity = Math.max(0, (op - 0.48) / 0.52);
    const isHovered = hoveredLetterId === l.id;

    return (
      <g key={l.id} transform={`translate(${l.x}, ${l.y})`} opacity={l.opacity}
         style={{ pointerEvents: 'none' }}>
        {/* Hover scale wrapper */}
        <g style={{
          transformBox: 'fill-box',
          transformOrigin: 'center',
          transform: `scale(${isHovered ? 1.08 : 1})`,
          transition: 'transform 0.22s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        }}>
          {/* Envelope body */}
          <rect x={-w/2} y={-h/2} width={w} height={h} rx="3.5"
            fill={`hsla(${l.hue}, 75%, 93%, 0.97)`}
            stroke={isHovered ? `hsla(${l.hue}, 80%, 52%, 0.95)` : `hsla(${l.hue}, 65%, 72%, 0.88)`}
            strokeWidth={isHovered ? '1.8' : '1'} />
          {/* Bottom V-fold */}
          <path d={`M${-w/2},${h/2} L0,${h*0.08} L${w/2},${h/2}`}
            fill="none" stroke={`hsla(${l.hue}, 55%, 76%, 0.4)`} strokeWidth="0.8" />
          {/* Animated flap (swings from closed → open) */}
          <path d={`M${-w/2},${-h/2} L0,${flapMidY} L${w/2},${-h/2}Z`}
            fill={`hsla(${l.hue}, 72%, 88%, 0.95)`}
            stroke={`hsla(${l.hue}, 65%, 72%, 0.88)`}
            strokeWidth="1" />
          {/* Message fades in once flap is ~half open */}
          {op > 0.45 && (
            <text x={0} y={h * 0.1} textAnchor="middle" dominantBaseline="middle"
              fontSize={Math.max(7, l.size * 0.21)}
              fill={`hsla(${l.hue + 15}, 52%, 28%, ${textOpacity * 0.94})`}
              style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', pointerEvents: 'none',
                       transition: 'opacity 0.4s ease' }}>
              {l.message}
            </text>
          )}
          {/* Heart seal */}
          <path d={heartPath(0, h * 0.36, l.size * 0.14)}
            fill={`hsla(${l.hue}, 80%, 62%, 0.85)`} />
        </g>
      </g>
    );
  };

  return (
    <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', zIndex: 99990, pointerEvents: 'none' }}>
      <style>{`
        @keyframes hintFadeIn { 0%{opacity:0;transform:translateY(20px)} 100%{opacity:1;transform:translateY(0)} }
        @keyframes valentinePulse {
          0%,100% { filter: drop-shadow(0 0 10px rgba(255,80,130,0.55)) }
          50%      { filter: drop-shadow(0 0 28px rgba(255,80,130,1.0)) }
        }
      `}</style>

      {/* Soft rose ambient tint (during wave) */}
      <div style={{
        position: 'fixed', inset: 0, pointerEvents: 'none',
        background: isFlowActive
          ? 'radial-gradient(ellipse at 30% 50%, rgba(255,140,170,0.06) 0%, rgba(255,100,150,0.03) 100%)'
          : 'transparent',
        transition: 'background 1.2s ease',
      }} />

      <svg style={{ position: 'absolute', width: '100%', height: '100%', overflow: 'visible', pointerEvents: 'none' }}>
        <defs>
          <filter id="valGlow">
            <feGaussianBlur stdDeviation="3.5" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <filter id="valSoft">
            <feGaussianBlur stdDeviation="1.5" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
        </defs>

        {/* Floating hearts (RMB) */}
        {hearts.map(h => (
          <g key={h.id} transform={`translate(${h.x},${h.y})`} opacity={h.opacity} filter="url(#valSoft)">
            <path d={heartPath(0, 0, h.size * 0.42)}
              fill={`hsla(${h.hue}, 88%, 64%, 0.92)`} />
          </g>
        ))}

        {/* Micro hearts (RMB×2 burst) */}
        {microHearts.map(h => (
          <g key={h.id} transform={`translate(${h.x},${h.y}) scale(${h.scale})`} opacity={h.opacity}>
            <path d={heartPath(0, 0, h.size * 0.4)}
              fill={`hsla(${h.hue}, 84%, 66%, 0.88)`} />
          </g>
        ))}

        {/* Letters (LMB) */}
        {letters.map(renderLetter)}

        {/* Big valentine (RMB×2) */}
        {bigValentine && (() => {
          const bv = bigValentine;
          const s = 82 * bv.scale;
          const lines = bv.message ? bv.message.split('\n') : [];
          const lineH = 19;
          const totalH = lines.length * lineH;
          return (
            <g key={bv.id} transform={`translate(${bv.x},${bv.y})`} opacity={bv.opacity}
               style={{ animation: 'valentinePulse 0.75s ease-in-out infinite' }}>
              <path d={heartPath(0, 0, s * 0.42)}
                fill={`hsla(345, 86%, 60%, 0.96)`}
                filter="url(#valGlow)" />
              {bv.opened && lines.map((line, i) => (
                <text key={i} textAnchor="middle"
                  y={s * 0.18 - totalH / 2 + i * lineH}
                  fontSize="15"
                  fill="rgba(255,255,255,0.95)"
                  style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', pointerEvents: 'none',
                    filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.45))' }}>
                  {line}
                </text>
              ))}
            </g>
          );
        })()}

        {/* Love-wave flow particles (MMB hold) */}
        {flowParticles.map(p => (
          <g key={p.id} transform={`translate(${p.x},${p.y})`} opacity={p.opacity}>
            {p.type === 'heart' ? (
              <path d={heartPath(0, 0, p.size * 0.36)}
                fill={`hsla(${p.hue}, 82%, 68%, 0.9)`} />
            ) : (
              <circle r={p.size * 0.32}
                fill={`hsla(${p.hue}, 76%, 72%, 0.82)`} />
            )}
          </g>
        ))}
      </svg>

      {showHint && (
        <div style={{
          position: 'fixed', bottom: '160px', left: '50%', transform: 'translateX(-50%)',
          background: 'linear-gradient(135deg, rgba(140,20,70,0.93), rgba(200,50,100,0.93))',
          backdropFilter: 'blur(16px)', borderRadius: '16px', padding: '14px 22px',
          border: '1px solid rgba(255,150,190,0.4)',
          color: 'rgba(255,215,230,0.97)', fontSize: '13px',
          animation: 'hintFadeIn 0.4s ease', pointerEvents: 'none', whiteSpace: 'nowrap', zIndex: 99999
        }}>
          💌 ЛКМ — письма · ПКМ — сердечки · ПКМ×2 — валентинка · Wheel — волна любви
        </div>
      )}
      {/* Hover tooltip — HTML for proper text wrapping */}
      {hoveredLetterId && (() => {
        const l = letters.find(x => x.id === hoveredLetterId);
        if (!l || !l.message || (l.openProgress || 0) < 0.48) return null;
        const vw = window.innerWidth;
        const rawLeft = l.x;
        const rawTop = l.y - l.size * 0.6;
        const cardW = 230;
        const clampedLeft = Math.min(Math.max(rawLeft, cardW / 2 + 8), vw - cardW / 2 - 8);
        return (
          <div key={l.id} style={{
            position: 'absolute',
            left: clampedLeft,
            top: rawTop,
            transform: 'translate(-50%, calc(-100% - 12px))',
            background: `hsla(${l.hue}, 65%, 97%, 0.98)`,
            border: `1.5px solid hsla(${l.hue}, 60%, 74%, 0.9)`,
            borderRadius: 12,
            padding: '10px 14px',
            maxWidth: cardW,
            width: 'max-content',
            boxShadow: `0 8px 28px rgba(200,60,110,0.20), 0 2px 8px rgba(200,60,110,0.12)`,
            pointerEvents: 'none',
            animation: 'hintFadeIn 0.18s ease',
            zIndex: 1,
          }}>
            <p style={{
              margin: 0,
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: 14,
              lineHeight: 1.55,
              color: `hsla(${l.hue + 10}, 55%, 26%, 0.96)`,
              textAlign: 'center',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}>
              {l.message}
            </p>
          </div>
        );
      })()}
    </div>
  );
};

export default ValentineMode;
